import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { PurchaseHistoryItemDto } from '../dtos';

export class PurchaseHistoryState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public purchaseHistoryItems: Array<PurchaseHistoryItemDto>;

  constructor() {
    this.purchaseHistoryItems = new Array<PurchaseHistoryItemDto>();
    this.isLoading = false;
    this.failures = null;
  }
}
